import { IconSearch, IconCustomSearch } from 'components/Icons'
import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface ButtonSearchProps {
  customSearchBar?: boolean
}

const ButtonSearch: React.FC<ButtonSearchProps> = (props) => {
  const { customSearchBar = false } = props
  const { t } = useTranslation()
  return (
    <StyledButtonSearch type="submit" title={t('search')}>
      {customSearchBar ? <IconCustomSearch /> : <IconSearch />}
    </StyledButtonSearch>
  )
}

const StyledButtonSearch = styled.button`
  width: 48px;
  height: 48px;
  background: none;
  border: none;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.icon};
  cursor: pointer;
`
export default ButtonSearch
